/* ============================================================================
   ROWMAN — cart
   Replaces the prototype's localStorage cart with Shopify's Cart AJAX API.
   Drawer and cart page share one render path, so the clinical intake manifest
   layout is identical in both. All prices come from Shopify, never the DOM.
   ============================================================================ */
(function () {
  'use strict';

  var R = window.ROWMAN;
  if (!R) return;

  var routes = R.routes || {};
  var strings = R.strings || {};

  /* ───────────────────────── API ───────────────────────── */

  function req(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body || {})
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || strings.cartError);
          err.payload = data;
          throw err;
        }
        return data;
      });
    });
  }

  var Cart = {
    get: function () {
      return fetch((routes.cartUrl || '/cart') + '.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json(); });
    },
    add: function (items) {
      return req(routes.cartAddUrl || '/cart/add.js', { items: items });
    },
    change: function (key, quantity) {
  var url = routes.cartChangeUrl || '/cart/change';
  return req(url.replace(/\.js$/, '') + '.js', { id: key, quantity: quantity });
},
    clear: function () {
      return req(routes.cartClearUrl || '/cart/clear.js', {});
    }
  };
  R.Cart = Cart;

  /* ───────────────────────── shared render ───────────────────────── */

  function setBusy(on) {
    document.querySelectorAll('[data-cart-root]').forEach(function (el) {
      el.classList.toggle('is-busy', !!on);
      el.setAttribute('aria-busy', on ? 'true' : 'false');
    });
  }

  function updateBubbles(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  }

  /**
   * Re-render every cart surface on the page by fetching the cart sections
   * from Shopify. Using Section Rendering keeps markup authored in Liquid,
   * so the drawer and page never drift from the approved design.
   */
  function refresh(openDrawer) {
    var ids = [];
    document.querySelectorAll('[data-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });

   var url = (routes.rootUrl || '/') + '?sections=' + ids.join(',');

    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        ids.forEach(function (id) {
          if (!sections[id]) return;
          var doc = new DOMParser().parseFromString(sections[id], 'text/html');
          var fresh = doc.querySelector('[data-cart-section="' + id + '"]');
          document.querySelectorAll('[data-cart-section="' + id + '"]').forEach(function (target) {
            if (!fresh) return;
            target.innerHTML = fresh.innerHTML;
            R.mountAll(target);
          });
        });
        return Cart.get();
      })
      .then(function (cart) {
        updateBubbles(cart.item_count);
        R.announce(
          cart.item_count === 0
            ? (strings.cartEmpty || 'Cart is empty')
            : (strings.cartUpdated || 'Cart updated') + ' — ' +
              cart.item_count + ' ' +
              (cart.item_count === 1 ? (strings.item || 'item') : (strings.items || 'items'))
        );
        if (openDrawer) openCartDrawer();
        document.dispatchEvent(new CustomEvent('rowman:cart:updated', { detail: cart }));
        return cart;
      })
      .catch(function (err) {
        console.error('[ROWMAN] cart refresh failed', err);
      });
  }
  R.refreshCart = refresh;

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && drawer.rowmanOpen) drawer.rowmanOpen();
  }
  R.openCartDrawer = openCartDrawer;

  function showError(scope, message) {
    var box = (scope || document).querySelector('[data-cart-error]');
    if (!box) { R.toast(message); return; }
    box.textContent = message;
    box.hidden = false;
    box.classList.add('is-error');
    setTimeout(function () { box.hidden = true; }, 6000);
  }

  /* ═══════════════════ MODULE: cart drawer ═══════════════════ */

  R.register({
    name: 'CartDrawer',
    scope: '[data-cart-drawer]',
    mount: function (drawer) {
      var overlay = document.querySelector('[data-cart-overlay]');
      var openers = Array.prototype.slice.call(document.querySelectorAll('[data-cart-open]'));
      var closeBtn = drawer.querySelector('[data-cart-close]');
      var lastFocus = null;
      var releaseTrap = null;

      function open(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        lastFocus = document.activeElement;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) {
          overlay.classList.add('is-open');
          overlay.setAttribute('aria-hidden', 'false');
        }
        document.body.classList.add('cart-open');
        openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
        releaseTrap = R.trapFocus(drawer);
        var f = drawer.querySelector(R.FOCUSABLE);
        if (f) f.focus();
      }
      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (overlay) {
          overlay.classList.remove('is-open');
          overlay.setAttribute('aria-hidden', 'true');
        }
        document.body.classList.remove('cart-open');
        openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
        if (releaseTrap) { releaseTrap(); releaseTrap = null; }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function onKey(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      }

      drawer.rowmanOpen = open;

      // Delegated so a Theme Editor header reload can never orphan the binding
      function onDocClick(e) {
        var trigger = e.target.closest('[data-cart-open]');
        if (trigger) open(e);
      }
      document.addEventListener('click', onDocClick);
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (overlay) overlay.addEventListener('click', close);
      document.addEventListener('keydown', onKey);

      return function () {
        document.removeEventListener('click', onDocClick);
        if (closeBtn) closeBtn.removeEventListener('click', close);
        if (overlay) overlay.removeEventListener('click', close);
        document.removeEventListener('keydown', onKey);
        document.body.classList.remove('cart-open');
        delete drawer.rowmanOpen;
      };
    }
  });

  /* ═══════════════════ MODULE: cart line controls ═══════════════════
     Bound at document level via delegation so it survives every section
     re-render without rebinding. */

  R.register({
    name: 'CartLines',
    scope: null,
    mount: function () {
      function onClick(e) {
        var btn = e.target.closest('[data-cart-action]');
        if (!btn) return;
        e.preventDefault();

        var action = btn.getAttribute('data-cart-action');
        var line = btn.closest('[data-line-key]');
        if (!line) return;
        var key = line.getAttribute('data-line-key');
        var qty = parseInt(line.getAttribute('data-line-qty') || '1', 10);

        var next;
        if (action === 'increase') next = Math.min(99, qty + 1);
        else if (action === 'decrease') next = qty - 1;
        else if (action === 'remove') next = 0;
        else return;

        setBusy(true);
        Cart.change(key, next)
          .then(function () { return refresh(false); })
          .catch(function (err) { showError(line.closest('[data-cart-root]'), err.message); })
          .then(function () { setBusy(false); });
      }

      function onChange(e) {
        var input = e.target.closest('[data-cart-qty-input]');
        if (!input) return;
        var line = input.closest('[data-line-key]');
        if (!line) return;
        var key = line.getAttribute('data-line-key');
        var next = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));

        setBusy(true);
        Cart.change(key, next)
          .then(function () { return refresh(false); })
          .catch(function (err) { showError(line.closest('[data-cart-root]'), err.message); })
          .then(function () { setBusy(false); });
      }

      document.addEventListener('click', onClick);
      document.addEventListener('change', onChange);
      return function () {
        document.removeEventListener('click', onClick);
        document.removeEventListener('change', onChange);
      };
    }
  });

  /* ═══════════════════ MODULE: add to cart forms ═══════════════════ */

  R.register({
    name: 'AddToCart',
    scope: '[data-product-form]',
    mount: function (form) {
      function onSubmit(e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var idInput = form.querySelector('[name="id"]');
        if (!idInput || !idInput.value) {
          showError(form, strings.selectVariant || 'Select an option');
          return;
        }
        var qtyInput = form.querySelector('[name="quantity"]');
        var item = {
          id: parseInt(idInput.value, 10),
          quantity: parseInt((qtyInput && qtyInput.value) || '1', 10)
        };

        // line item properties, if the section renders any
        var props = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (p) {
          var name = p.getAttribute('name').replace(/^properties\[|\]$/g, '');
          if (p.value) props[name] = p.value;
        });
        if (Object.keys(props).length) item.properties = props;

        if (btn) { btn.classList.add('rw-btn-loading'); btn.disabled = true; }

        Cart.add([item])
          .then(function () { return refresh(R.cartType === 'drawer'); })
          .then(function () { R.toast(strings.addedToCart || 'Added to cart'); })
          .catch(function (err) { showError(form, err.message); })
          .then(function () {
            if (btn) { btn.classList.remove('rw-btn-loading'); btn.disabled = false; }
          });
      }
      form.addEventListener('submit', onSubmit);
      return function () { form.removeEventListener('submit', onSubmit); };
    }
  });

  /* ═══════════════════ MODULE: quick-add on product cards ═══════════════════
     Preserves the prototype's hover dropdown. Options and availability come
     from the Shopify variant data rendered into the card by Liquid. */

  R.register({
  name: 'QuickAdd',
  scope: '[data-quick-add]',

  mount: function (root) {
    var trigger = root.querySelector('[data-quick-add-trigger]');
    var panel = root.querySelector('[data-quick-add-panel]');
    var variantData = root.querySelector('[data-quick-add-variants]');

    var directVariantId = trigger
      ? trigger.getAttribute('data-direct-variant-id')
      : null;

    if (!trigger) return;

    var variants = [];

    if (variantData) {
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        console.error('[ROWMAN] Quick-add variant data failed', error);
      }
    }

    var groups = panel
      ? Array.prototype.slice.call(
          panel.querySelectorAll('[data-option-group]')
        )
      : [];

    /*
      ROWMAN option order:
      1. Size
      2. Color
      3. Any additional product option
    */
    function groupPriority(group) {
      var name = group.getAttribute('data-option-name') || '';

      if (name.indexOf('size') !== -1) {
        return 0;
      }

      if (
        name.indexOf('color') !== -1 ||
        name.indexOf('colour') !== -1
      ) {
        return 1;
      }

      return 2;
    }

    groups.sort(function (a, b) {
      return groupPriority(a) - groupPriority(b);
    });

    var selected = {};
    var currentStep = 0;
    var busy = false;

    function setOpen(open) {
      if (panel) {
        panel.hidden = !open;
        panel.classList.toggle('is-open', open);
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      }

      trigger.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeOtherPanels() {
      document.querySelectorAll('[data-quick-add]').forEach(function (item) {
        if (item === root) return;

        var otherPanel = item.querySelector('[data-quick-add-panel]');
        var otherTrigger = item.querySelector('[data-quick-add-trigger]');

        if (otherPanel) {
          otherPanel.hidden = true;
          otherPanel.classList.remove('is-open');
          otherPanel.setAttribute('aria-hidden', 'true');
        }

        if (otherTrigger) {
          otherTrigger.classList.remove('is-open');
          otherTrigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function variantMatchesSelections(variant, ignoredIndex) {
      return Object.keys(selected).every(function (key) {
        var index = parseInt(key, 10);

        if (index === ignoredIndex) {
          return true;
        }

        return variant.options[index] === selected[key];
      });
    }

    function updateAvailability(group) {
      if (!variants.length) return;

      var optionIndex = parseInt(
        group.getAttribute('data-option-index'),
        10
      );

      group.querySelectorAll('[data-option-choice]').forEach(function (button) {
        var value = button.getAttribute('data-option-value');

        var possible = variants.some(function (variant) {
          return (
            variant.available &&
            variant.options[optionIndex] === value &&
            variantMatchesSelections(variant, optionIndex)
          );
        });

        button.disabled = !possible;
        button.classList.toggle('is-soldout', !possible);
        button.setAttribute(
          'aria-disabled',
          possible ? 'false' : 'true'
        );
      });
    }

    function showStep() {
      groups.forEach(function (group, index) {
        var active = index === currentStep;

        group.hidden = !active;

        if (active) {
          updateAvailability(group);
        }
      });
    }

    function resetFlow() {
      selected = {};
      currentStep = 0;

      groups.forEach(function (group) {
        group
          .querySelectorAll('[data-option-choice]')
          .forEach(function (button) {
            button.classList.remove('is-selected');
            button.setAttribute('aria-pressed', 'false');
          });
      });

      showStep();
    }

    function selectedLabel() {
      return groups
        .map(function (group) {
          var index = group.getAttribute('data-option-index');
          return selected[index] || '';
        })
        .filter(Boolean)
        .join(' / ');
    }

    function showCardConfirmation(label) {
      var card = root.closest('.release-card, .chamber');

      if (!card) return;

      var previous = card.querySelector('.qa-toast');

      if (previous) {
        previous.remove();
      }

      var confirmation = document.createElement('span');

      confirmation.className = 'qa-toast';
      confirmation.textContent =
        '✓ ADDED' +
        (label ? ' · ' + label.toUpperCase() : '');

      card.appendChild(confirmation);

      window.setTimeout(function () {
        confirmation.remove();
      }, 1800);
    }

    function addVariant(variantId, label, button) {
      if (!variantId || busy) return;

      busy = true;
      trigger.disabled = true;
      trigger.classList.add('rw-btn-loading');

      if (button) {
        button.disabled = true;
        button.classList.add('rw-btn-loading');
      }

      Cart.add([
        {
          id: parseInt(variantId, 10),
          quantity: 1
        }
      ])
        .then(function () {
          /*
            Update the cart count without immediately opening the drawer.
            This keeps the card-level confirmation visible.
          */
          return refresh(false);
        })
        .then(function () {
          setOpen(false);
          showCardConfirmation(label);

          R.announce(
            (strings.addedToCart || 'Added to cart') +
              (label ? ' — ' + label : '')
          );
        })
        .catch(function (error) {
          showError(root, error.message);
        })
        .then(function () {
          busy = false;
          trigger.disabled = false;
          trigger.classList.remove('rw-btn-loading');

          if (button) {
            button.disabled = false;
            button.classList.remove('rw-btn-loading');
          }
        });
    }

    function togglePanel(event) {
      event.preventDefault();
      event.stopPropagation();

      /*
        If only one purchasable variant exists,
        add it immediately without opening a picker.
      */
      if (directVariantId) {
        addVariant(directVariantId, '', trigger);
        return;
      }

      if (!panel) return;

      var willOpen =
        panel.hidden ||
        !panel.classList.contains('is-open');

      closeOtherPanels();

      if (willOpen) {
        resetFlow();
      }

      setOpen(willOpen);
    }

    function selectOption(event) {
      /*
        Compatibility with the existing collection-card
        quick add, which still uses direct variant buttons.
      */
      var legacyVariantButton =
        event.target.closest('[data-variant-id]');

      if (legacyVariantButton) {
        event.preventDefault();
        event.stopPropagation();

        if (legacyVariantButton.disabled) return;

        addVariant(
          legacyVariantButton.getAttribute('data-variant-id'),
          legacyVariantButton.textContent.trim(),
          legacyVariantButton
        );

        return;
      }

      var button = event.target.closest('[data-option-choice]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.disabled) return;

      var optionIndex = parseInt(
        button.getAttribute('data-option-index'),
        10
      );

      var optionValue =
        button.getAttribute('data-option-value');

      selected[optionIndex] = optionValue;

      var group = button.closest('[data-option-group]');

      group
        .querySelectorAll('[data-option-choice]')
        .forEach(function (choice) {
          var active = choice === button;

          choice.classList.toggle('is-selected', active);
          choice.setAttribute(
            'aria-pressed',
            active ? 'true' : 'false'
          );
        });

      /*
        Move seamlessly into the next option window.
        Size appears first; Color appears second when needed.
      */
      if (currentStep < groups.length - 1) {
        currentStep++;
        showStep();
        return;
      }

      var matchingVariant = variants.find(function (variant) {
        if (!variant.available) return false;

        return Object.keys(selected).every(function (key) {
          var index = parseInt(key, 10);

          return variant.options[index] === selected[key];
        });
      });

      if (matchingVariant) {
        addVariant(
          matchingVariant.id,
          selectedLabel(),
          button
        );
      }
    }

    function closeOutside(event) {
      if (!root.contains(event.target)) {
        setOpen(false);
      }
    }

    function closeWithEscape(event) {
      if (event.key === 'Escape') {
        setOpen(false);
        trigger.focus();
      }
    }

    setOpen(false);

    trigger.addEventListener('click', togglePanel);

    if (panel) {
      panel.addEventListener('click', selectOption);
    }

    document.addEventListener('click', closeOutside);
    document.addEventListener('keydown', closeWithEscape);

    return function () {
      trigger.removeEventListener('click', togglePanel);

      if (panel) {
        panel.removeEventListener('click', selectOption);
      }

      document.removeEventListener('click', closeOutside);
      document.removeEventListener('keydown', closeWithEscape);
    };
  }
});

  /* ═══════════════════ MODULE: pre-checkout review handoff ═══════════════════
     §9.1 option B. The theme never collects payment data. This button posts
     the customer into Shopify's hosted checkout. */

  R.register({
    name: 'CheckoutHandoff',
    scope: '[data-checkout-handoff]',
    mount: function (btn) {
      function go(e) {
        e.preventDefault();
        if (btn.getAttribute('aria-disabled') === 'true') return;
        btn.classList.add('rw-btn-loading');
        R.announce(strings.redirectingToCheckout || 'Redirecting to secure checkout');
        window.location.href = routes.cartUrl ? routes.cartUrl + '/checkout' : '/checkout';
      }
      btn.addEventListener('click', go);
      return function () { btn.removeEventListener('click', go); };
    }
  });

  /* ═══════════════════ MODULE: shipping country note ═══════════════════
     Informational only — real rates are calculated by Shopify at checkout. */

  R.register({
    name: 'ShippingNote',
    scope: '[data-shipping-country]',
    mount: function (select) {
      var note = document.querySelector('[data-shipping-note]');
      function onChange() {
        if (!note) return;
        var opt = select.options[select.selectedIndex];
        note.textContent = (strings.shippingCalculated ||
          'Rates and duties for {country} are calculated at checkout.')
          .replace('{country}', opt ? opt.textContent.trim() : '');
      }
      select.addEventListener('change', onChange);
      onChange();
      return function () { select.removeEventListener('change', onChange); };
    }
  });

}());
